(() => {
  const init = (root) => {
    if (root.dataset.holidayReady) return;
    root.dataset.holidayReady = 'true';
    const panels = Array.from(root.querySelectorAll('[data-holiday-panel]'));
    const controls = Array.from(root.querySelectorAll('[data-holiday-filter]'));
    const filterBar = root.querySelector('[data-holiday-filters]');
    const shop = root.querySelector('.rr-holiday__shop');
    const status = root.querySelector('[data-holiday-status]');
    const show = (key, scroll = false) => {
      const selected = panels.find(panel => panel.dataset.holidayPanel === key);
      if (!selected) return;
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      controls.forEach(control => {
        const current = control.dataset.holidayFilter === key;
        if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(current));
        else if (current) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      });
      if (status) status.textContent = selected.dataset.holidayLabel;
      if (scroll && shop) shop.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    };
    controls.forEach(control => control.addEventListener('click', event => {
      event.preventDefault();
      show(control.dataset.holidayFilter, control.tagName === 'A');
    }));
    if (filterBar) filterBar.hidden = false;
    const hashPanel = panels.find(panel => '#' + panel.id === location.hash);
    show(hashPanel ? hashPanel.dataset.holidayPanel : 'all');
  };
  const mount = (scope) => scope.querySelectorAll('[data-holiday-hub]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
